<template>
  <div>
    梦鱼专属测试文件
    <form-money-input
      :formData="formData"
      renderSence="edit"
      propKey="money"
      :widget="{
        label: '金额组件',
        placeholder: '请输入金额',
        numberMax: 200
      }"
    ></form-money-input>
    <form-email-input
      :formData="formData"
      renderSence="read"
      propKey="email"
      :widget="{
        label: '邮箱组件',
        placeholder: '请输入邮箱'
      }"
    ></form-email-input>
    <form-phone-input
      :formData="formData"
      renderSence="edit"
      propKey="phone"
      :widget="{
        label: '手机号组件',
        placeholder: '请输入手机号'
      }"
    ></form-phone-input>
    <form-idcard-input
      :formData="formData"
      renderSence="edit"
      propKey="idcard"
      :widget="{
        label: '证件号组件',
        placeholder: '请输入身份证号'
      }"
    ></form-idcard-input>
    <form-document-number
      :formData="formData"
      renderSence="edit"
      propKey="docuemntNumber"
      :widget="documentNumberWidget"
    ></form-document-number>
    <!-- <x-input-phone v-model="formData.phone"></x-input-phone> -->
    <cube-button @click="handleClick">
      测试dialog
    </cube-button>
    <form-upload
      renderSence="edit"
      :formData="formData"
      propKey="upload"
      :widget="{
        fileMaxSize: 1,
        fileMaxNum: 1,
        fileType: ['img', 'word'],
        label: '上传组件'
      }"
    ></form-upload>
    <!-- <x-empty></x-empty> -->
    <cube-button @click="handleOpen">
      打开弹框
    </cube-button>
    <x-modal title="审批历史" :visible.sync="visible"></x-modal>
    <approval-history ref="approvalHistory"></approval-history>

    <form-department-select
      :formData="formData"
      renderSence="edit"
      propKey="department"
      :widget="{
        label: '部门选择'
      }"
    ></form-department-select>
  </div>
</template>

<script>
import ApprovalHistory from '@/components/approval-history/approval-history'
import {
  SET_COMP_PAYLOAD,
  CLEAR_COMPROUTER_STORE
} from '@/store/comp-router.store.js'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'DreamfishTest',
  components: {
    ApprovalHistory
  },
  inject: ['addKeepAlive', 'removeKeepAlive'],
  provide() {
    return {
      compRouter: {
        push: this.compRouterPush
      }
    }
  },
  data() {
    return {
      visible: false,
      compRoutes: {},
      formData: {
        money: '2222222',
        email: '2511907843@qq.com',
        phone: '15926567629',
        idcard: '140321199802111811',
        docuemntNumber: 'IR00000032',
        uploadEmpty: [],
        upload: [{ 'fileName': 'logo.png', 'fileType': 'image', 'fileSize': 10488, 'fileSizeStr': '10.0 KB', 'creatorName': '王周健', 'creationDate': '2020-07-28 15:36:39', 'url': 'http://portal.definesys.com:30502/xdap-app/attachments/downloadFile?file=5aac50ca-ae89-4c7a-9523-acc2599f9da5', 'id': '75974782579904512', 'tenantId': '58644709379145729', 'status': 'completed', 'owner': '58644700285894656', 'createdBy': '58644700285894656', 'lastUpdatedBy': '58644700285894656', 'lastUpdateDate': '2020-07-28 15:36:39', 'objectVersionNumber': 1, 'userId': '58644700285894656', 'ossBucketName': 'xdap-app-dev', 'ossObjectName': '5aac50ca-ae89-4c7a-9523-acc2599f9da5', 'uploadId': '1595921800364' }, { 'fileName': '1592652769025.jpeg', 'fileType': 'image', 'fileSize': 104413, 'fileSizeStr': '101.0 KB', 'creatorName': '王周健', 'creationDate': '2020-07-28 15:36:45', 'url': 'http://portal.definesys.com:30502/xdap-app/attachments/downloadFile?file=eda1fd31-7bc2-463d-8755-4cd388195527', 'id': '75974807561179136', 'tenantId': '58644709379145729', 'status': 'completed', 'owner': '58644700285894656', 'createdBy': '58644700285894656', 'lastUpdatedBy': '58644700285894656', 'lastUpdateDate': '2020-07-28 15:36:45', 'objectVersionNumber': 1, 'userId': '58644700285894656', 'ossBucketName': 'xdap-app-dev', 'ossObjectName': 'eda1fd31-7bc2-463d-8755-4cd388195527', 'uploadId': '1595921806309' }]
      },
      documentNumberWidget: {
        label: '证件号组件',
        placeholder: '请输入身份证号',
        documentNumRules: [
          { 'ruleType': 'STATIC_TEXT', 'staticText': 'IR' },
          { 'waterRuleId': 'cd8e6a03-5df9-0314-432a-66c4db91a26f', 'ruleType': 'WATER_CODE', 'resetType': 'NEVER', 'placeSpace': 8 }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      compPayload: state => state.compRouterModule.compPayload
    })
  },
  beforeRouteLeave(to, from, next) {
    next()
  },
  activated() {
    if (this.compPayload) {
      this.removeKeepAlive(this.$options.name)
      if (!this.compPayload[this.compPayload.activeKey].value) {
        return
      }
      const keys = this.compPayload.activeKey.split('.')
      if (keys.length > 1) { // 表格
        if (keys[1] === 'add') {
          if (this.compPayload[this.compPayload.activeKey].value.$deleted) {
            return
          }
          let tableData = this.formData[keys[0]]
          if (!tableData) {
            tableData = []
          }
          tableData.unshift(this.compPayload[this.compPayload.activeKey].value)
          this.$set(this.formData, keys[0], tableData)
          this.formData = { ...this.formData }
          this.clearCompRoterStore(this.compPayload.activeKey)
        } else {
          const index = Number(keys[1])
          const compPayloadValue = this.compPayload[this.compPayload.activeKey].value
          if (compPayloadValue.$deleted) {
            let tableData = this.formData[keys[0]]
            if (tableData) {
              tableData.splice(index, 1)
              this.$set(this.formData, keys[0], tableData)
            }
          } else {
            this.$set(this.formData[keys[0]], index, compPayloadValue)
          }
          this.$set(this.formData, keys[0], this.formData[keys[0]])
          this.formData = { ...this.formData }
          this.clearCompRoterStore(this.compPayload.activeKey)
        }
      } else {
        this.$set(this.formData, this.compPayload.activeKey, this.compPayload[this.compPayload.activeKey].value)
        this.formData = { ...this.formData }
        this.clearCompRoterStore(this.compPayload.activeKey)
      }
    }
  },
  methods: {
    ...mapMutations('compRouterModule', {
      setCompPayload: SET_COMP_PAYLOAD,
      clearCompRoterStore: CLEAR_COMPROUTER_STORE
    }),
    compRouterPush(compName, compPayload) {
      this.setCompPayload(compPayload) // key widgetConfig value
      this.addKeepAlive(this.$options.name)
      this.$nextTick(() => {
        this.$router.push({
          name: compName
        })
      })
    },
    handleClick() {
      this.$confirm({
        message: '是否确定删除该文件？',
        okConfig: {
          title: '确定',
          onOk() {
            console.log('确定')
          }
        },
        cancelConfig: {
          title: '取消',
          onCancel() {
            console.log('取消')
          }
        }
      })
    },
    handleOpen() {
      // this.visible = true
      this.$refs.approvalHistory && this.$refs.approvalHistory.openModal()
    }
  }
}
</script>

<style>
</style>
